module.exports = __webpack_public_path__ + "static/media/icons-dark-gray-help.c8fb6fed.svg";